import React from "react";

export default function Annexure3(props) {
  return (
    <div>
      <div className="flex flex-row justify-between items-center">
        <h1 className="text-3xl font-bold mb-6 text-yellow-500">
          Prohibited Practices (Never Adopt – Don’ts)
        </h1>
        <h2 className="text-2xl font-bold mb-6 text-yellow-500">Annexure-3</h2>
      </div>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <ul className="space-y-2 mb-1">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Never hit or otherwise physically assault or abuse children.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Never allow or engage in any form of inappropriate touching,
                intimate contact or relationship with a child. Never develop
                relationships with children which could in any way be seen as
                exploitative or abusive
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Never allow or engage in rough, physical or sexually provocative
                games, including horseplay
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Never share a room with a child or invite or allow children to
                stay with you at your home unsupervised. Similarly, never sleep
                in the same room as a child if this has not been agreed by their
                parent/guardian
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Never allow adults to enter children’s rooms or invite children
                into their rooms at tournaments or residential events.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Never use language or make suggestions which are inappropriate,
                offensive or abusive. At the same time, never allow children to
                use inappropriate language unchallenged
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Never allow or make sexually suggestive comments to a child,
                even in fun
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Never reduce a child to tears as a form of control
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Never fail to act record and report any allegations made by a
                child
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Never do things of a personal nature for children or disabled
                adults, that they can do for themselves
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Never push children including disabled children against their
                will.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Never act in ways meant to shame, humiliate, belittle or degrade
                children
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Never show differential treatment, or favor particular children
                to the exclusion of others
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Never spend excessive time alone with children away from others
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Never develop intimate and/or sexual relationships with children
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Never expose children to pornographic materials in electronic or
                any other form
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Never permit children to take part in activities that are
                illegal, unsafe or abusive
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Never take or condone the taking of illegal drugs or drink
                alcohol when working with children (or prior to contact)
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Never enter a child’s private home unless there is a responsible
                adult present
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
